import React from "react";
import {connect} from "react-redux";
import SubmitButton from "../../recorder/components/SubmitButton";
import { CITIES } from "./cities";
import {registrationAttributesChanged, registerUser} from "../actions/authenticationActions";
import Header from "../../common/components/Header";
import DropDown from "./DropDown";
import TextInput from "./TextInput";
import {MAIN_CONTENT} from "../../styles";

const errorColor = "rgb(217, 83, 79)";

export const RegisterUser = (props) => {
    const errors = props.errors.map(e =>
        <div key={e} style={{color: errorColor}}>{e}</div>
    );
    return (
        <div style={MAIN_CONTENT}>
            <Header>Register for an account</Header>
            <div className="pure-form pure-form-aligned">
                <div style={{borderBottom: "1px solid #ddd", padding: 10}}>
                    <TextInput attribute="firstName" {...props} >First name</TextInput>
                    <TextInput attribute="lastName" {...props} >Last name</TextInput>
                    <TextInput attribute="email" {...props} >Email</TextInput>
                    <TextInput attribute="jobRole" {...props} >Job title</TextInput>
                    <TextInput attribute="regulatingAuthority" {...props} >Regulating authority</TextInput>
                    <DropDown label="City you are located in"
                              values={CITIES}
                              selected={props.city}
                              onChange={city => props.onAttributesChange({ city })}
                              inputId="city"
                              highlightError={props.attributesWithErrors.includes("city")} />
                </div>
                <div style={{padding: 10, display: (props.errors.length > 0) ? "block" : "none"}}>
                    { errors }
                </div>
                <div style={{backgroundColor: "#eee", padding: 10}}>
                    <div style={{marginLeft: "11em"}}>
                        <SubmitButton disabled={props.recordingInProgress}
                                      onSubmit={props.onSubmit}>
                            { props.recordingInProgress ? "Recording..." : "Register" }
                        </SubmitButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
RegisterUser.propTypes = {
    firstName: React.PropTypes.string,
    lastName: React.PropTypes.string,
    email: React.PropTypes.string,
    jobRole: React.PropTypes.string,
    regulatingAuthority: React.PropTypes.string,
    city: React.PropTypes.string,
    attributesWithErrors: React.PropTypes.arrayOf(React.PropTypes.string),
    errors: React.PropTypes.arrayOf(React.PropTypes.string),
    onAttributesChange: React.PropTypes.func
};
RegisterUser.defaultProps = {
    attributesWithErrors: []
};

const mapStateToProps = (state) => Object.assign( {
        attributesWithErrors: state.authentication.registration.attributesWithErrors,
        errors: state.authentication.registration.submissionStatus.errors
    },
    state.authentication.registration.attributes);

export const mapDispatchToProps = (dispatch, ownProps) => ({
    onAttributesChange: attributes => dispatch(registrationAttributesChanged(attributes)),
    onSubmit: () => dispatch(registerUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/RegistrationForm.js
 **/